import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';

export default function DashboardRFString() {
  const state = useContext(MainContext).state;

  const frames = [
    { label: 'R2', value: state.R2 },
    { label: 'R3', value: state.R3 },
    { label: 'R4', value: state.R4 },
    { label: 'R5', value: state.R5 },
    { label: 'R6', value: state.R6 },
    { label: 'R7', value: state.R7 },
    { label: 'R9', value: state.R9 },
    { label: 'RA', value: state.RA },
    { label: 'RB', value: state.RB },
    { label: 'RC', value: state.RC },
    { label: 'RE', value: state.RE },
    { label: 'RG', value: state.RG },

    ...(state.RH
      ? [{ label: 'RH', value: state.RH }]
      : []),
  ];

  return (
    <React.Fragment>
      <Typography
        component="h2"
        variant="h6"
        sx={{ color: 'white', mb: 1, fontWeight: 600 }}
      >
        RF String
      </Typography>

      <Paper
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {frames.map((frame) => (
            <Box key={frame.label}>
              <Chip
                label={frame.label}
                size="small"
                sx={{
                  bgcolor: 'rgba(255,255,255,0.06)',
                  color: 'rgba(255,255,255,0.9)',
                  fontSize: 15,
                  height: 22,
                  mb: 0.5,
                }}
              />

              <Typography
                component="pre"
                sx={{
                  m: 0,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  fontFamily: 'monospace',
                  fontSize: 14,
                  color: 'rgba(255,255,255,0.7)',
                }}
              >
                {frame.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Paper>
    </React.Fragment>
  );
}
